import { QuarterRange } from "../models/Scorecard";
import API from "./api";

export const GetScorecardDetails = (baseUrl: string, providerNpi: string, quarterRange: QuarterRange) =>
  API.get(`${baseUrl}GetScorecardDetails?npi=${providerNpi}&quarterBegin=${quarterRange.quarterBegin}&quarterEnd=${quarterRange.quarterEnd}`);

export const GetExcelDownload = (baseUrl: string, providerNpi: string, quarterRange: QuarterRange) =>
  API.get(`${baseUrl}ScorecardExcelFile?npi=${providerNpi}&quarterBegin=${quarterRange.quarterBegin}&quarterEnd=${quarterRange.quarterEnd}`, "excel");

export const GetScorecardBaselineTable = (baseUrl: string, providerState: string, quarterRange: QuarterRange, pcmNpi: string) =>
  API.get(`${baseUrl}ScorecardBaselineTable?state=${providerState}&quarterBegin=${quarterRange.quarterBegin}&quarterEnd=${quarterRange.quarterEnd}&pcmNpi=${pcmNpi}`);
